import React, { useState, useEffect, useRef, useCallback } from "react";
import Sidebar from "../../../../components/sidebar";
import { Link, useOutletContext } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style.scss";
import DateGreyIcon from "../../../../icons/DateGreyIcon";
import ClockGreyIcon from "../../../../icons/ClockGreyIcon";
import { useDispatch, useSelector } from "react-redux";
import { FaChevronRight } from "react-icons/fa";
import { getReportList } from "../../../../core/data/redux/report/_reportAction";
import { apiPageLimit } from "../../../../constants/common";
import { CommonPagination } from "../../../../core/components/common/CommnPagination";



const GeneratedReports: React.FC = () => {
  const { isSidebarOpen } = useOutletContext<{ isSidebarOpen: boolean; onToggleSidebar: () => void }>();
  const dispatch: any = useDispatch();

  const reportDetails = useSelector((state: any) => state?.report);
  const reportList = reportDetails?.reportList;
  const totalCount = reportDetails?.totalCount;

  const [page, setPage] = useState<number>(1);
  const pageSize = apiPageLimit;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";


  useEffect(() => {
    dispatch(getReportList({timezone}));
  }, [dispatch]);

  const totalPages = Math.ceil(totalCount / pageSize);

  // Debounce search
  const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  // Fetch with debounce
  const fetchReports = useCallback(
    debounce((page: number) => {
      const params: any = { page, limit: pageSize, timezone };
      dispatch(getReportList(params));
    }, 500),
    [dispatch]
  );

  // Run when page changes
  useEffect(() => {
    fetchReports(page);
  }, [page]);

  // Download report handler
  const handleDownload = async (fileUrl: string) => {
    try {
      // Fetch the file as a blob
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("File download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Extract filename from the URL or default
      const filename = fileUrl.split("/").pop() || "report";

      // Create a temporary link and trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };



  return (
    <div className="layout ">
      <Sidebar isOpen={isSidebarOpen} />

      <main className="content">
        <div className="profileSettings report-page-section">
          <div className=" rounded report-page-inner generated-report-content">
            <div className="add-properties-heading d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
              <h2 className="mb-0">Generated Reports</h2>
            </div>

            <div className="all-reports">
              {reportList?.length > 0 ? (
                reportList?.map((report: any) => {
                  return (
                    <div
                      className={`single-report-col d-flex justify-content-between align-items-center ${report?.file_type?.toLowerCase() == "pdf" ? "red-report"
                        : report?.file_type?.toLowerCase() == "docx" ? "green-report"
                          : report?.file_type?.toLowerCase() == "xlsx" ? "ltgreen-report"
                            : report?.file_type?.toLowerCase() == "csv" ? "ltgreen-report"
                              : "white-report"
                        }`}
                    >
                      <div className="report-data d-flex flex-column gap-1">
                        <h3 className="MB-0">{report?.name}</h3>
                        <span><DateGreyIcon />&nbsp; {report?.created_date}</span>
                        <span><ClockGreyIcon />&nbsp; {report?.created_time}</span>
                      </div>

                      <div className="report-download-btn d-flex justify-content-center align-items-center flex-row gap-2">
                        <button
                          className="file-type-btn d-flex justify-content-center flex-column"
                          style={{ background: 'transparent', border: 'none' }}
                          onClick={() => { handleDownload(report?.file) }}
                        >
                          <img
                            src={report?.file_type?.toLowerCase() == "pdf" ? "/assets/img/pdf-icon.svg" : report?.file_type?.toLowerCase() == "docx" ? "/assets/img/xls-icon.svg" : report?.file_type?.toLowerCase() == "xlsx" ? "/assets/img/xls-icon.svg" : report?.file_type?.toLowerCase() == "csv" ? "/assets/img/csv-icon.svg" : "/assets/img/txf-icon.svg"}
                            alt="report-icon"
                          />
                          Download
                        </button>

                        <span className="text-center"><FaChevronRight /></span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="text-center w-100 py-4">No data found.</p>
              )}
            </div>
          </div>

          <div className="reports-pagination d-flex justify-content-end flex-row flex-wrap gap-1 mt-4">
            {/* Pagination */}
            <CommonPagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default GeneratedReports;
